import { ControlsSnapshot, MonthlyEnabledControlsSnapshot } from 'Models/Dashboards';
import { Effectiveness, effectivenessAsString } from 'Models/OperationalControls';
import { getEffectivenessChartColor } from 'Pages/Dashboards/Helpers/Dashboards.helpers';

import { AssessmentsBarChartDataRow } from '../DueDiligenceDashboard/DueDiligenceDashboard.helpers';
import { ComplianceModalType } from './ComplianceRequirements/ComplianceRequirementDisplayModal/ComplianceRequirementDisplayModal';

export const buildControlOverTimeChartByMonth = (controlsHistory: ControlsSnapshot[], displayValues: Effectiveness[]): AssessmentsBarChartDataRow[] => {
    return displayValues.map((displayValue: Effectiveness) => {
        return {
            data: controlsHistory.map((control) => control.assessments.filter((assessment) => assessment.effectiveness === displayValue).length),
            name: effectivenessAsString(displayValue),
            color: getEffectivenessChartColor(displayValue),
        };
    });
};

export const buildControlEffectivenessSnapshotByMonth = (controlsHistory: MonthlyEnabledControlsSnapshot[], displayValues: Effectiveness[]): AssessmentsBarChartDataRow[] => {
    return displayValues.map((effectiveness) => {
        return {
            data: controlsHistory.map((controlSnapshot: MonthlyEnabledControlsSnapshot) => controlSnapshot.controls.filter((control) => control.effectiveness.control_effectiveness === effectiveness).length),
            name: effectivenessAsString(effectiveness),
            color: getEffectivenessChartColor(effectiveness),
        };
    });
};

export const stringToEffectiveness = (effectivenessText: string) => {
    switch (effectivenessText) {
        case 'Unrated':
            return Effectiveness.UNRATED;
        case 'Fail':
            return Effectiveness.FAIL;
        case 'Weak':
            return Effectiveness.WEAK;
        case 'Moderate':
            return Effectiveness.MODERATE;
        case 'Strong':
            return Effectiveness.STRONG;
        case 'Robust':
            return Effectiveness.ROBUST;
    }
};

export const stringToComplianceModalType = (requirementString: string) => {
    switch (requirementString) {
        case 'Met':
            return ComplianceModalType.MET;

        case 'Unmet':
            return ComplianceModalType.UNMET;

        case 'Not Assessed':
            return ComplianceModalType.NOT_ASSESSED;

        case 'Not Mapped':
            return ComplianceModalType.NOT_MAPPED;
    }
};
